import { createStore } from 'vuex'
import { createInertiaApp } from '@inertiajs/vue3'
import axios from 'axios'
import { axiosAdapter, http } from '@inertiajs/core'
import { ToastPlugin } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import modules from './store/modules'
import Popper from 'vue3-popper'
import translation from './translation'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { i18nVue } from 'laravel-vue-i18n'
import LaravelPermissionsToVue from './plugins/LaravelPermissionsToVue'
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { domPurifyOptions } from '~conciergeUiCommons/libs/dompurify';

let store = new createStore({
    modules
})


// Only initialize Inertia if the app element and data-page element exist
// to avoid console errors when other pages are loaded
const el = document.getElementById('app')
const dataPage = document.querySelector('[data-page="app"]')
if (!el || !dataPage) {
    // Not an Inertia page, skip initialization
} else {

    createInertiaApp({
        pages: { path: './Pages', lazy: false },
        http: axiosAdapter(axios),
        withApp(app) {
            app
                .component('Popper', Popper)
                .use(LaravelPermissionsToVue)
                .use(i18nVue, {
                    resolve: async lang => {
                        const langs = import.meta.glob('../../lang/*.json')
                        return await langs[`../../lang/${lang}.json`]()
                    }
                })
                .use(store)
                .use(ToastPlugin)
                .use(VueSweetalert2)
                .use(VueDOMPurifyHTML, domPurifyOptions)
                .mixin(translation) //legacy lang
        }
    })
}
